import Box from '@mui/material/Box';
import { Button, Paper, Typography } from '@mui/material';
import { SubMenuIcon, BackIcon } from '@/components/Shared/Icons';
import { useTranslation } from 'react-i18next';

type Items = {
  name: string;
  onClick: any;
  onClickParam: any;
  icon: any;
};

export type MenuDropdownProps = {
  title: string;
  items: Items[];
  setPortal: any;
  setPortalValue?: any;
  handleLogout?: any;
};

export default function MobilePortal({
  title,
  items,
  setPortal,
  setPortalValue = false,
  handleLogout = null,
}: MenuDropdownProps) {
  const { t } = useTranslation();

  return (
    <Paper
      sx={(theme) => ({
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
        visibility: { xs: 'visible', md: 'hidden' },
        width: '100%',
        height: '100%',
        background: theme.palette.elevation01?.main,
        color: theme.palette.text.primary,
        zIndex: 3,
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'scroll',
      })}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: '40px',
          paddingBottom: '20px',
        }}
      >
        <BackIcon
          viewBox="0 0 8 14"
          style={{ width: '8px', height: '14px' }}
          onClick={() => setPortal(setPortalValue)}
          data-testid="portal-back-button"
        />
        <Typography
          textAlign="left"
          sx={{
            fontWeight: 600,
            fontSize: 16,
            marginLeft: '20px',
            textTransform: 'capitalize',
          }}
        >
          {title}
        </Typography>
      </Box>
      {items.map((item: any) => (
        <Button
          disabled={item.disabled && true}
          key={item.name}
          onClick={(e) => {
            item.onClick(item.onClickParam ? item.onClickParam : e);
          }}
          sx={(theme) => ({
            padding: '20px',
            marginLeft: '20px',
            marginRight: '20px',
            borderBottom: '0.2px solid rgba(77, 82, 88, 0.1)',
            color: theme.palette.text.primary,
          })}
          data-testid={`settings-menu-${item.name}`}
        >
          <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
            {item.icon !== false && (
              <Box sx={{ width: '24px', height: '24px' }}>{item.icon}</Box>
            )}
            <Typography
              textAlign="center"
              sx={{
                marginLeft: '20px',
                fontSize: 14,
                textTransform: 'capitalize',
              }}
            >
              {item.name}
            </Typography>
            {item.hasSubMenu && (
              <Box
                sx={{
                  marginLeft: 'auto',
                  marginRight: 0,
                  width: '8px',
                  height: '14px',
                }}
              >
                <SubMenuIcon />
              </Box>
            )}
          </Box>
        </Button>
      ))}
      {handleLogout && (
        <Box
          sx={{
            position: 'absolute',
            bottom: '30px',
            left: 0,
            right: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
            width: '90vw',
          }}
        >
          <Button
            variant="contained"
            sx={{
              width: '100%',
              borderRadius: '20px',
              fontSize: '16px',
              fontWeight: '600',
              textTransform: 'capitalize',
            }}
            onClick={handleLogout}
            data-testid="mobile-logout-button"
          >
            {t('sidenav.logout')}
          </Button>
        </Box>
      )}
    </Paper>
  );
}
